import React from "react";

import { IFilterValue } from "../../../../../../types/form-type";
import {
  ITableColumn,
  ICurrencyTypeOptions,
  IRatingOptions,
  INumberTypeOptions,
  ITypeOptions,
  ColumnType,
} from "../../../../../../types/table-type";

import { HIDE_FILTER_INPUT_BY_CONDITION, getFinalColumnType } from "../../../../../../utils/filter_secondary";

import AttachmentSelector from "../AttachmentSelector";
import DateComparison from "../DateComparison";
import SelectSelector from "../SelectSelector";
import Checkbox from "../Checkbox";
import DefaultInput from "../DefaultInput";
import CurrencyInput from "../CurrencyInput";
import NumberInput from "../NumberInput";
import CollaboratorSelect from "../CollaboratorSelect";
import RatingInput from "../RatingInput";
import AutoNumberInput from "../AutoNumberInput";

import { Container } from "./styled";
import { StatusSelector } from "../StatusSelector";


interface IProps {
  column?: ITableColumn;
  value: IFilterValue;
  onChange: (data: { [key in string]: any }) => void;
  shareUserId: string;
}

const ValueInput: React.FC<IProps> = ({ column, value, onChange, shareUserId }) => {
  if (!column) return null;
  // 如果选择 为空 不为空 无需展示 ValueInput
  const hideEmpties = !!HIDE_FILTER_INPUT_BY_CONDITION[value.filterCondition];
  if (hideEmpties) return null;

  // 需要告诉 每个子 控件    该控件修改的是 IFilterValue 的哪个字段
  // 本层仅做 控件分类 没有其他逻辑
  // 或者直接在 子控件 中写死id

  let InputComponent: React.ReactNode;
  const basicProps = {
    name: "1",
    value: value,
    onChange: onChange,
  };
  const columnType = getFinalColumnType({ ...column.typeOptions, type: column.type } as ITypeOptions, true);
  switch (columnType) {
    case ColumnType.MULTI_ATTACHMENT:
      InputComponent = <AttachmentSelector onChange={onChange} value={value} name="1" />;
      break;
    case ColumnType.RATING:
      InputComponent = (
        <RatingInput name={"1"} value={value} onChange={onChange} typeOptions={column.typeOptions as IRatingOptions} />
      );
      break;
    case ColumnType.DATETIME:
    case ColumnType.CREATED_AT:
      InputComponent = <DateComparison name="1" value={value} onChange={onChange} />;
      break;
    case ColumnType.STATUS:
      InputComponent = <StatusSelector name="1" value={value} onChange={onChange} column={column} />;
      break;
    case ColumnType.SELECT:
    case ColumnType.MULTI_SELECT:
      InputComponent = <SelectSelector name="1" value={value} onChange={onChange} column={column} />;
      break;
    case ColumnType.CHECKBOX:
      InputComponent = <Checkbox name="1" value={value} onChange={onChange} />;
      break;
    case ColumnType.CURRENCY:
      InputComponent = (
        <CurrencyInput
          name="1"
          value={value}
          onChange={onChange}
          typeOptions={column.typeOptions as ICurrencyTypeOptions}
        />
      );
      break;
    case ColumnType.NUMBER:
      InputComponent = (
        <NumberInput value={value} onChange={onChange} typeOptions={column.typeOptions as INumberTypeOptions} />
      );
      break;
    case ColumnType.COLLABORATOR:
    case ColumnType.CREATED_BY:
      InputComponent = <CollaboratorSelect value={value} onChange={onChange} columnType={column.type} shareUserId={shareUserId} />;
      break;
    case ColumnType.AUTO_NUMBER:
      InputComponent = <AutoNumberInput {...basicProps} />;
      break;
    default:
      InputComponent = <DefaultInput {...basicProps} />;
      break;
  }

  return <Container>{InputComponent}</Container>;
};

export default ValueInput;
